module.exports = __webpack_public_path__ + "static/media/flatfy.7257f170.svg";